
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetohyderabad() {



    const cardData =
    {
        keyword: 'Pune to Hyderabad Cab',
        heading: 'Meghana Cab : Pune to Hyderabad Cab',
        headingDescription: 'Meghana Cab offers Pune to Hyderabad Cab services, delivering a smooth and reliable long-distance travel experience. Whether you are traveling for business, leisure, or a family trip, our fleet of comfortable, AC cabs driven by experienced chauffeurs ensures a safe and enjoyable ride. We offer flexible pickup times, affordable pricing, and 24/7 customer support to make your journey worry-free. Book your Pune to Hyderabad Cab with Meghana Cab and enjoy the perfect blend of comfort, punctuality, and professionalism.',


        top: 'Top Places to Visit in Hyderabad with Meghana Cab',

 "topPlaces": [
  {
    "title": "Charminar",
    "description": "Constructed in 1591 by Muhammad Quli Qutb Shah, this iconic 56 m granite structure features four imposing minarets and arches. Symbolizing the founding of Hyderabad, it also houses a mosque on its top floor. Surrounded by the vibrant Laad Bazaar and near Mecca Masjid, Charminar is an architectural masterpiece, cultural hub, and UNESCO tentative‑listed monument, alive with markets, festivals, and history."
  },
  {
    "title": "Golconda Fort",
    "description": "Originally a Kakatiya-era mud fort, later transformed by the Qutb Shahi dynasty into an expansive granite citadel with eight gates and 87 bastions. Renowned for its ingenious acoustic design—whispers at the entrance are heard atop the Bala Heens—this fort also features rainwater harvesting, the famous ‘Rahban’ cannon, royal prison cells, and a spectacular sound-and‑light show set in the ramparts come evening."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "This majestic complex, built over the 18th–19th centuries, was the seat of the Nizams and is named for its four palatial courtyards. Highlights include the grand Khilwat Darbar Hall with crystal chandeliers, European-imported vintage cars, and beautifully restored fountains and gardens. After extensive renovation, it now showcases regal opulence and frequently hosts cultural events."
  },
  {
    "title": "Falaknuma Palace",
    "description": "Once home to the Paigah and later the Nizam family, this palatial estate—whose name means 'Mirror of the Sky'—sits gracefully atop a hillock. Built between 1884–1893 in Tudor and Italian style, the palace features a 32-acre estate, 60 rooms, a hand-carved walnut library, a grand ballroom with a rare manual pipe organ, and 40 Venetian chandeliers. Now restored by the Taj Group, it operates as a luxury heritage hotel."
  },
  {
    "title": "Hussain Sagar & Buddha Statue",
    "description": "A 5.7 km² heart-shaped artificial lake built in 1562, Hussain Sagar connects Hyderabad and Secunderabad. At its center stands a 58 ft white granite monolith of Buddha, erected in 1992 on Gibraltar Rock. The glimmering Tank Bund promenade features bronze statues, dancing fountains, NTR Gardens, boat rides, and lakeside leisure options like Eat Street and Snow World."
  },
  {
    "title": "Birla Mandir",
    "description": "Perched on Naubat Pahad hill, this serene white marble temple dedicated to Lord Venkateswara shines with a fusion of Dravidian, Rajasthani, and Utkala architecture. Completed in 1976 by the Birla Foundation, the temple is known for its peaceful ambiance, absence of bells (promoting meditative silence), and panoramic city views."
  },
  {
    "title": "Ramoji Film City",
    "description": "Sprawling across nearly 2000 acres, Ramoji Film City is one of the world’s largest integrated film studio complexes. Apart from filming sets, it offers theme-park rides, live shows, film studio tours, restaurants, and gardens—perfect for a family outing or entertainment-packed day trip."
  },
  {
    "title": "Nehru Zoological Park & NTR Gardens",
    "description": "Adjacent to Hussain Sagar, the Nehru Zoo spans over 300 acres and houses species like tigers, sloth bears, and rhinoceros. Nearby, NTR Gardens offers 55 acres of landscaped greenery, walking paths, boating ponds, and a memorial to N.T. Rama Rao, making for a refreshing, family‑friendly outdoor escape."
  },
  {
    "title": "Purani Haveli & Chowmahalla District",
    "description": "Purani Haveli—also called the ‘Old Palace’—was the official residence of the Nizams and now hosts a museum displaying their personal belongings, vintage clocks, and European-style architecture. The surrounding Old City area further immerses you in traditional bazaars, historic mosques, spice shops, and authentic street food."
  },
  {
    "title": "Kalakriti Art Gallery & Shilparamam",
    "description": "For art and culture lovers, Kalakriti exhibits rich contemporary and folk art from across India, while Shilparamam offers an immersive craft village experience. Both venues showcase regional artists, live performances, handicrafts, and an authentic glimpse into traditional Indian cultural expression."
  }
],

 "services": [
    {
        "name": "Pune to Hyderabad Long-Distance Cab",
        "description": "Travel comfortably across states with Meghana Cab’s long-distance cab service from Pune to Hyderabad. Perfect for business trips, family travel, or personal tours, our well-maintained vehicles and experienced drivers ensure a safe, efficient, and hassle-free intercity journey."
    },
    {
        "name": "One Way Taxi Pune to Hyderabad",
        "description": "Need a single drop to Hyderabad from Pune? Book Meghana Cab’s one-way taxi for affordable and convenient travel. Our service includes flexible pick-up locations, AC comfort, and experienced drivers for a smooth highway drive."
    },
    {
        "name": "Round Trip Cab Pune to Hyderabad",
        "description": "Planning a return trip from Pune to Hyderabad? Meghana Cab offers round-trip cab bookings with reliable service, excellent car condition, and professional chauffeurs who stay with you throughout your journey for a stress-free experience."
    },
    {
        "name": "Intercity Taxi Pune to Hyderabad",
        "description": "Meghana Cab’s intercity taxi service connects Pune to Hyderabad seamlessly. Our intercity taxis are ideal for both personal and business needs, featuring on-time pickup, clean cars, and real-time support during your trip."
    },
    {
        "name": "AC Sedan Hire Pune to Hyderabad",
        "description": "Hire a comfortable AC sedan for your Pune to Hyderabad trip with Meghana Cab. Ideal for small families or solo travelers, our sedans come with spacious seating, smooth suspension, and trained chauffeurs for a relaxed long ride."
    },
    {
        "name": "Pune to Hyderabad SUV Taxi",
        "description": "Book an SUV taxi from Pune to Hyderabad with Meghana Cab for extra space, comfort, and road performance. Our SUVs are perfect for group travel or when carrying luggage, providing both comfort and power on longer drives."
    },
    {
        "name": "Budget Cab to Hyderabad from Pune",
        "description": "Looking for a cost-effective way to travel to Hyderabad from Pune? Meghana Cab offers budget cab options that combine affordability with reliability, clean interiors, and no hidden charges for your peace of mind."
    },
    {
        "name": "Pune to Hyderabad Cab with Driver",
        "description": "Enjoy a relaxed trip from Pune to Hyderabad with Meghana Cab’s driver-included service. Our trained drivers know the route well and focus on your safety and punctuality, so you can sit back and enjoy the ride."
    },
    {
        "name": "Book Outstation Taxi to Hyderabad",
        "description": "Heading to Hyderabad from Pune? Book your outstation taxi with Meghana Cab for a smooth, long-distance travel experience. Choose from hatchbacks, sedans, or SUVs with expert drivers and fair pricing."
    },
    {
        "name": "Online Cab Hire Pune to Hyderabad",
        "description": "Meghana Cab makes it easy to hire a cab from Pune to Hyderabad online. Our user-friendly booking system gives you instant confirmation, flexible car options, and secure payment modes for a seamless experience."
    },
    {
        "name": "Pune to Hyderabad Corporate Taxi",
        "description": "For business professionals, Meghana Cab offers corporate taxi services from Pune to Hyderabad with invoice support, clean executive vehicles, and timely pickups — ideal for client visits or business meetings."
    },
    {
        "name": "Pune to Hyderabad Taxi Fare",
        "description": "Check Pune to Hyderabad taxi fares upfront with Meghana Cab. Our transparent pricing model helps you plan your budget with no hidden fees — just fair rates, well-maintained vehicles, and courteous drivers."
    },
    {
        "name": "Pune to Hyderabad Distance by Car",
        "description": "Planning to travel the Pune to Hyderabad distance by car? Meghana Cab offers insights on travel time, rest stops, and the best routes — along with dependable cabs that make the long drive enjoyable and safe."
    },
    {
        "name": "Pune to Hyderabad Safe Taxi",
        "description": "Your safety is our top priority. Meghana Cab’s safe taxi service from Pune to Hyderabad includes verified drivers, sanitized vehicles, real-time tracking, and 24/7 support — perfect for solo travelers and families alike."
    },
    {
        "name": "Cab for Pune to Hyderabad Travel",
        "description": "Whether it's a weekend getaway, emergency travel, or a planned trip, Meghana Cab provides dependable cab services for Pune to Hyderabad journeys. Choose your ride, set your time, and enjoy a comfortable trip door to door."
    }
],

"tableData": [
    ["Pune to Hyderabad Long-Distance Cab", "One Way Taxi Pune to Hyderabad"],
    ["Round Trip Cab Pune to Hyderabad", "Intercity Taxi Pune to Hyderabad"],
    ["AC Sedan Hire Pune to Hyderabad", "Pune to Hyderabad SUV Taxi"],
    ["Budget Cab to Hyderabad from Pune", "Pune to Hyderabad Cab with Driver"],
    ["Book Outstation Taxi to Hyderabad", "Online Cab Hire Pune to Hyderabad"],
    ["Pune to Hyderabad Corporate Taxi", "Pune to Hyderabad Taxi Fare"],
    ["Pune to Hyderabad Distance by Car", "Pune to Hyderabad Safe Taxi"],
    ["Cab for Pune to Hyderabad Travel", ""],
    ["", ""]
],







"whychoose": [
    {
        "WhyChooseheading": "Comfortable Pune to Hyderabad Cab Service",
        "WhyChoosedescription": "Meghana Cab offers a reliable and comfortable cab service from Pune to Hyderabad. Whether you're traveling for business, a family visit, or leisure, enjoy a smooth long-distance journey in our well-maintained vehicles."
    },
    {
        "WhyChooseheading": "Timely Pick-Up and Drop-Off",
        "WhyChoosedescription": "Long-distance travel requires punctuality. Our Pune to Hyderabad cab service ensures timely pick-up and drop-off, helping you stay on schedule without any stress."
    },
    {
        "WhyChooseheading": "Expert Drivers for Intercity Travel",
        "WhyChoosedescription": "Our experienced drivers are trained for long-distance routes and are well-versed with the Pune to Hyderabad highway. They prioritize your safety and comfort throughout the journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Enjoy competitive and transparent pricing with Meghana Cab. Our Pune to Hyderabad cab fares are budget-friendly with no hidden charges, making it easy to plan your trip."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles",
        "WhyChoosedescription": "Your safety is our top priority. Our cabs are sanitized before every trip and come equipped with modern safety features like seat belts, GPS tracking, and emergency assistance."
    },
    {
        "WhyChooseheading": "24/7 Pune to Hyderabad Cab Booking",
        "WhyChoosedescription": "Travel anytime with our 24/7 cab availability. Whether it’s a daytime ride or an overnight journey, Meghana Cab is ready to serve you with dependable long-distance travel service."
    },
    {
        "WhyChooseheading": "Custom Travel Plans for Your Journey",
        "WhyChoosedescription": "Need to make stops or have a return trip planned? We offer customizable Pune to Hyderabad cab packages to suit your travel preferences and itinerary."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Customer Support",
        "WhyChoosedescription": "Book your Pune to Hyderabad cab quickly through our user-friendly website or mobile app. Our customer support team is also available to assist with bookings and queries for a smooth experience."
    }
]
















    }

const faqData = [
    {
        question: "How can I book a Pune to Hyderabad cab with Meghana Cab?",
        answer: "You can book a cab from Pune to Hyderabad easily via Meghana Cab's website or by calling our support team at +91 9075462128."
    },
    {
        question: "What cab types are available for the Pune to Hyderabad route?",
        answer: "We offer hatchbacks, sedans, SUVs, and tempo travellers for long-distance travel like Pune to Hyderabad, depending on your comfort and group size."
    },
    {
        question: "How long does it take to travel from Pune to Hyderabad by cab?",
        answer: "The road journey from Pune to Hyderabad usually takes around 10 to 12 hours depending on traffic and road conditions."
    },
    {
        question: "Can I book a one-way cab from Pune to Hyderabad?",
        answer: "Yes, Meghana Cab provides affordable one-way cab services from Pune to Hyderabad along with round-trip options."
    },
    {
        question: "Are tolls and taxes included in the fare for Pune to Hyderabad?",
        answer: "Tolls, state taxes, and any parking charges are additional and transparently mentioned during the booking process."
    },
    {
        question: "Is it safe to travel long distance with Meghana Cab drivers?",
        answer: "Yes, all our drivers are professionally trained, background-verified, and experienced in long-distance routes such as Pune to Hyderabad."
    },
    {
        question: "Can I make multiple stops during the Pune to Hyderabad cab trip?",
        answer: "Yes, we can arrange planned stops on the way. Please let us know your requirements while booking the cab."
    },
    {
        question: "Do your Pune to Hyderabad cabs operate at night?",
        answer: "Yes, Meghana Cab offers 24/7 service, allowing you to book cabs for early morning, daytime, or overnight journeys."
    },
    {
        question: "What payment options are available for Pune to Hyderabad cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments for your convenience."
    },
    {
        question: "How can I contact Meghana Cab for Pune to Hyderabad cab service?",
        answer: "For bookings or queries, call Meghana Cab at +91 9075462128. We’re available to assist you 24/7."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Ravi Menon',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I booked Meghana Cab for a trip from Pune to Hyderabad and the entire experience was seamless. The cab was comfortable, and the driver was very cooperative and safe.”',
    },
    {
        name: 'Mrs. Leena Reddy',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Our long-distance travel from Pune to Hyderabad with Meghana Cab was excellent. The driver was well-versed with the route and the journey was very comfortable. Highly recommend their service!”',
    },
];












































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Hyderabad Cab",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-hyderabad-cab.jpg",
  "description": "Book a reliable cab from Pune to Hyderabad with Meghana Cabs. Available for one-way and round trips with AC, Sedan, and SUV options. Comfortable and affordable outstation travel.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5332"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-hyderabad-cab"
  }
};







    return (
        <div>
<Helmet>
  <title>Pune to Hyderabad Cab | One Way & Round Trip | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book a reliable cab from Pune to Hyderabad with Meghana Cabs. Available for one-way and round trips with AC, Sedan, and SUV options. Comfortable and affordable outstation travel." 
  />
  <meta 
    name="keywords" 
    content="Pune to Hyderabad Taxi Booking, One Way Cab to Hyderabad, Round Trip Taxi Pune to Hyderabad, Budget Cabs Pune to Hyderabad, Pune to Hyderabad Road Trip Cab, AC Taxi Service to Hyderabad from Pune, Outstation Cab for Hyderabad, Pune to Hyderabad Sedan Cab, Pune to Hyderabad SUV Hire, Online Cab Booking Pune to Hyderabad, Car Hire for Hyderabad Journey, Pune to Hyderabad Intercity Cab, 24/7 Cab Service to Hyderabad, Pune to Hyderabad Cab Fare Estimate, Hire Driver for Pune to Hyderabad" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/4.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetohyderabad;